<template>
    <div class="mobile-logo hidden-md-and-up">
        <div class="logo text-center">
            <router-link to="/">
            <img src="/img/login-screens/Logo.png" alt="nutron logo" />
            </router-link>
        </div>
    </div>
</template>

<script>
    export default {
        name: "AuthNutronMobileLogo"
    }
</script>

<style scoped>

</style>
